import React, { useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import MobileMenu from "../components/MobileMenu"

const Contact: React.FC = () => {
	const navigate = useNavigate()

	// SEO Meta Tags

	const meta = {
		// title: "Mit merci zum Muttertag filmreif Danke sagen!",
		// canonical: "https://arvato-hawaiian-tropic-2023.de/",
		// meta: {
		// name: {
		// robots: "noindex, nofollow",
		// },
		// },
	}

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])

	return (
		<div>
			<div className="bg-greenBG md:min-h-[1400px] bg-[url('/src/bgimages/bg-green.png')] bg-full bg-no-repeat bg-[100%] bg-cover">
				<MobileMenu />
				<div className="mx-auto   py-8 px-4 text-white">
					<div className="mx-auto max-w-[800px]">
						<h2 className="h2 mb-8 mt-24 text-center font-Veener text-[32px] md:text-[52px] text-white lg:mt-24">Kontakt</h2>
						<h3 className="h3 py-4 text-white mb-0 text-[24px] md:text-[42px]">Du hast eine Frage, Anregungen oder Kritik?</h3>
						<p className="mb-4 text-center">Dann nimm gerne Kontakt mit uns auf. Wir freuen uns über Deine Nachricht!</p>
						<p className="mb-4 text-center">
							<a href="mailto:info@volvic-gratis-testen.de" className="underline">
								info@volvic-gratis-testen.de
							</a>
						</p>
						<p className="text-center">
							Allgemeine Informationen zur Aktion findest du außerdem in den{" "}
							<Link className="underline" to="/teilnahmebedingungen">
								Teilnahmebedingungen
							</Link>
							.
						</p>
					</div>
					<div className=" py-10 pt-5 text-center text-xl text-white">
						<Link
							to="/"
							className=" tracking-wide mb-6 block w-[100%] rounded-full bg-[#FFDD08]   p-4 font-Veener text-[29px]  sm:text-[32px] leading-none uppercase text-[#007331] sm:w-[auto]  lg:inline-block lg:py-4 lg:px-4"
						>
							Zurück
						</Link>
					</div>
				</div>
			</div>
		</div>
	)
}
export default Contact
